import { useEffect, useState, useCallback } from "react";
import { Modal } from "../components/Modal";
import { HostIcons } from "../components/HostIcons";
import { InstallPrompt } from "../components/InstallPrompt";
import { LogViewer } from "../components/LogViewer";
import "../css/style.css";
import "../css/zerogrid.css";
import "../css/menu.css";
import "../css/modern-dashboard.css";
import api from '../api';

export default function Main({ host, setHost, changePage }) {
    const [hostList, setHostList] = useState([]);
    const [hostsWithTodayIncome, setHostsWithTodayIncome] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isRefreshing, setIsRefreshing] = useState(false);

    // 데이터 로딩 함수
    const loadData = useCallback(async () => {
      try {
        // 호스트 목록 가져오기
        const hostResponse = await api.get(`/getHostSet`);
        if (hostResponse.status === 200) {
          setHostList(hostResponse.data);
        }

        // 오늘 수입이 있는 호스트 목록 가져오기
        const incomeResponse = await api.get(`/getHostWithTodayIncome`);
        if (incomeResponse.status === 200) {
          setHostsWithTodayIncome(incomeResponse.data);
        }
      } catch (error) {
        console.error('데이터 로딩 실패:', error);
      }
    }, []);

    // 새로고침 버튼 기능
    const handleRefresh = useCallback(async () => {
      if (isRefreshing) return;
      
      setIsRefreshing(true);
      
      // 햅틱 피드백
      if (navigator.vibrate) {
        navigator.vibrate(100);
      }
      
      await loadData();
      
      // 최소 1초 대기 (사용자 경험)
      await new Promise(resolve => setTimeout(resolve, 1000));
      setIsRefreshing(false);
    }, [isRefreshing, loadData]);

    useEffect(() => {
      loadData();
    }, [loadData]);
  
    return (
      <div className="modern-dashboard main-page">
        <section className="modern-container">
          <div className="wrap-container">
            <div className="admin-header">
              <div className="admin-title-section">
                <h1 className="admin-title">
                  <i className="fas fa-anchor me-3"></i>
                  Nautilus
                </h1>
                <p className="admin-subtitle">메인 페이지 - 호스트 관리 대시보드</p>
              </div>
              {/* 새로고침 버튼 */}
              <button 
                className="refresh-button"
                onClick={handleRefresh}
                disabled={isRefreshing}
                aria-label="데이터 새로고침"
              >
                <i className={`fas fa-sync-alt ${isRefreshing ? 'spinning' : ''}`}></i>
              </button>
            </div>
            <div className="modern-card main-content-card">
              <div className="card-header">
                <h4 className="card-title">
                  <i className="fas fa-server me-2"></i>
                  호스트 목록
                </h4>
                <span className="host-count">
                  총 {hostList.length}대 연결
                </span>
              </div>
              <div className="card-body">
                <div className="host-grid">
                  <HostIcons
                    hostList={hostList}
                    hostsWithTodayIncome={hostsWithTodayIncome}
                    onHostClick={(host) => {
                      setHost(host);
                      setShowModal(true);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <Modal
          visible={showModal}
          onClose={() => setShowModal(false)}
          hostName={host}
          changePage={changePage}
        />
        
        <InstallPrompt />
      </div>
    );
  }
  